<template>
  <li
    :aria-checked="
      extraOptionsStore.selectedOptions[productOptionCategory.id]?.id ===
      productOption.id
    "
    class="group relative w-[35vw] shrink-0 cursor-pointer select-none snap-start pb-4 md:w-56 md:min-w-56"
  >
    <div class="relative aspect-square w-full rounded-md md:h-56 md:w-56">
      <img
        :src="productOption.imageUrl ?? undefined"
        :alt="productOption.displayName"
        class="h-full w-full rounded-md border-2 border-gray-lightest object-cover group-aria-checked:border-green-lighter"
        draggable="false"
        @click="
          extraOptionsStore.toggleActiveProductOption(
            productOption,
            productOptionCategory,
            true
          )
        "
      />
      <CheckIcon
        class="not-sr-only absolute right-0 top-0 hidden h-10 w-10 rounded-bl-md rounded-tr-md bg-green-lighter p-2 text-white group-aria-checked:block"
      />
    </div>

    <div class="mt-2 text-base">
      <span v-text="productOption.displayName ?? productOption.name" />
      <div class="mt-2 flex gap-2">
        <span
          v-if="
            productOption.localizedRecommendedPrice &&
            productOption.price !== productOption.recommendedPrice
          "
          class="text-gray-light line-through"
          v-html="productOption.localizedRecommendedPrice"
        />
        <strong v-html="productOption.localizedPrice" />
      </div>
    </div>
  </li>
</template>

<script setup lang="ts">
import { useExtraOptionsStore } from '@/stores/ExtraOptionsStore';
import {
  ProductOptionCategoryObject,
  ProductOptionCategoryProductOptionObject,
} from '@/types/joostconnector';
import { CheckIcon } from '@heroicons/vue/24/outline';
import { PropType } from 'vue';

defineProps({
  productOptionCategory: {
    type: Object as PropType<ProductOptionCategoryObject>,
    required: true,
  },

  productOption: {
    type: Object as PropType<ProductOptionCategoryProductOptionObject>,
    required: true,
  },
});

const extraOptionsStore = useExtraOptionsStore();
</script>
